module.exports = __webpack_public_path__ + "media/iconfonts/pikawakaicon-11c62920f1988baad58e626960579d00.svg";